import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/data/site";

const wa = (n) =>
  `https://wa.me/91${n}?text=${encodeURIComponent("Hello Chakri Travels, I want to book a car rental service.")}`;

const links = [
  { l: "Home", h: "/" },
  { l: "About", h: "/about" },
  { l: "Services", h: "/services" },
  { l: "Contact", h: "/contact" },
];

const BrandLogo = () => (
  <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
    <div className="brand-logo-box">
      {BUSINESS.logo ? (
        <img src={BUSINESS.logo} alt="Chakri Travels logo" />
      ) : (
        <span className="font-display text-[var(--gold)] font-bold text-xl">C</span>
      )}
    </div>
    <div className="leading-tight">
      <p className="font-display text-[var(--royal-deep)] text-xl font-semibold tracking-tight">
        Chakri <span className="italic text-[var(--gold)]">Travels</span>
      </p>
      <p className="text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.2em] text-[var(--gold)]/90">
        {BUSINESS.tagline}
      </p>
    </div>
  </Link>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="navbar" className="sticky top-0 z-50 backdrop-blur bg-white/90 border-b border-[var(--royal)]/10">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 h-[76px] flex items-center justify-between">
        <BrandLogo />

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.l}
              to={l.h}
              end={l.h === "/"}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-[var(--royal-deep)]" : "text-[var(--muted-foreground)] hover:text-[var(--royal)]"
                }`
              }
            >
              {l.l}
            </NavLink>
          ))}
          <a
            data-testid="nav-call-btn"
            href={`tel:+91${BUSINESS.phones[0]}`}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--royal)] hover:text-[var(--gold)]"
          >
            <Phone size={14} /> +91 {BUSINESS.phones[0].slice(0, 5)} {BUSINESS.phones[0].slice(5)}
          </a>
          <Link
            to="/contact"
            data-testid="nav-book-btn"
            className="inline-flex items-center gap-2 rounded-full gradient-gold px-5 py-2.5 text-sm font-semibold text-[var(--royal-deep)] shadow-lg shadow-[var(--gold)]/30 hover:-translate-y-0.5 transition-transform"
          >
            Book Now
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-btn"
          className="md:hidden text-[var(--royal-deep)]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t border-[var(--border)]">
          <div className="px-5 py-5 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.l}
                to={l.h}
                end={l.h === "/"}
                onClick={() => setOpen(false)}
                className="text-foreground text-base font-medium"
              >
                {l.l}
              </NavLink>
            ))}
            <a
              href={`tel:+91${BUSINESS.phones[0]}`}
              className="inline-flex items-center justify-center gap-2 rounded-full gradient-gold px-5 py-3 text-sm font-semibold text-[var(--royal-deep)]"
            >
              <Phone size={14} /> Call +91 {BUSINESS.phones[0]}
            </a>
            <a
              href={wa(BUSINESS.primaryWhatsApp)}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-white"
            >
              <MessageCircle size={14} /> WhatsApp +91 {BUSINESS.primaryWhatsApp}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
